import { render, staticRenderFns } from "./ReleaseNotesSidePanel.vue?vue&type=template&id=4ff1d724&scoped=true"
import script from "./ReleaseNotesSidePanel.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesSidePanel.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNotesSidePanel.vue?vue&type=style&index=0&id=4ff1d724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff1d724",
  null
  
)

export default component.exports